/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import React from "react";
import ReactDOM from "react-dom";
import "./css/index.css";
import App from "./App";
import AppWithRsaFrames from "./AppWithRsaFrames";

function selectComponentBasedOnLocation() {
  const currentPath = window.location.href;

  if (currentPath.includes('localhost')) {
    return <AppWithRsaFrames />;
  } else {
    return <App />;
  }
}

ReactDOM.render(
  <React.StrictMode>
   {selectComponentBasedOnLocation()}
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
